export default __webpack_public_path__ + "static/Fall6-04e16f2dd667b287156872355d521933.mp3";